import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipologiaFormat',
  standalone: true,
})
export class TipologiaFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    switch (value) {
      case 'Centro_Pubblico':
        return 'Centro Pubblico';
      case 'Centro_Privato':
        return 'Centro Privato';
      case 'Centro_Prescrittore':
        return 'Centro Prescrittore';
      case 'Centro':
        return 'Centro Prescrittore';
      case 'PTwb':
        return 'Prescrittore con PTwb';
      case 'noPTwb':
        return 'Prescrittore senza PTwb';
      case 'Non_Identificato':
        return 'Non Identificato';
      default:
        return value;
    }
  }
}
